export enum DateFormat {
  YYYY_MM_DD = 'YYYY-MM-DD',
  MM = 'MM',
  DD = 'DD',
  DD_MM = 'DD_MM',
  HH_MM_SS = 'HH:mm:ss',
  HH_MM = 'HH:mm',
  HH_MM_SS_24 = 'HH:mm:ss (24h)',
  DD_MM_YYYY_HH_MM = 'DD/MM/YYYY HH:mm',
  DD_MM_YYYY = 'DD/MM/YYYY',
}
enum DateSeparator {
  HYPHEN = '-',
  SLASH = '/',
}

export const formatDate = (
  date: string | Date,
  format: DateFormat = DateFormat.YYYY_MM_DD,
  separator: DateSeparator = DateSeparator.HYPHEN
) => {
  let auxDate: Date;
  if (typeof date === 'string') {
    auxDate = new Date(date);
  } else {
    auxDate = date;
  }
  auxDate.toLocaleString();
  let result: string;
  if (format === DateFormat.YYYY_MM_DD) {
    // Use local date components instead of toISOString() to avoid timezone issues
    const year = auxDate.getFullYear();
    const month = String(auxDate.getMonth() + 1).padStart(2, '0');
    const day = String(auxDate.getDate()).padStart(2, '0');
    result = `${year}-${month}-${day}`;
  } else if (format === DateFormat.MM) {
    result = auxDate.toLocaleString('default', { month: 'short' });
  } else if (format === DateFormat.DD) {
    result = auxDate.toLocaleString('default', { day: 'numeric' });
  } else if (format === DateFormat.DD_MM) {
    result = auxDate.toLocaleString('default', { day: 'numeric', month: 'short' });
  } else if (format === DateFormat.HH_MM_SS) {
    result = auxDate.toLocaleString('default', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } else if (format === DateFormat.HH_MM_SS_24) {
    result = auxDate.toLocaleString('default', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  } else if (format === DateFormat.DD_MM_YYYY_HH_MM) {
    result = auxDate.toLocaleString('default', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } else if (format === DateFormat.HH_MM) {
    result = auxDate.toLocaleString('default', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } else if (format === DateFormat.DD_MM_YYYY) {
    result = auxDate.toLocaleString('default', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } else {
    throw new Error('Invalid format');
  }
  if (separator === DateSeparator.SLASH) {
    result = result.replace(/-/g, '/');
  }
  return result;
};
